module.exports = __webpack_public_path__ + "r-v3/img/ml_02_03.cbe90074.jpg";